export const ssn_regex =
  /^(?!666|000|9\d{2})(\d{3}|\*{3})-(?!00)(\d{2}|\*{2})-(?!0{4})\d{4}$/;

export const tin_ein_regex = /^(\d{3}|\*{3})-(\d{2}|\*{2})-(\d{4})$/;

export const zipcode_regex = /^\d{5}(-\d{4})?$/;

export const phone_regex =
  /^(\+1\s?)?(\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/;
